import React, {useEffect, useState} from 'react';
import {auth, db} from "../../services/firebase";
import {Main} from "../../components";
import UserItem from "../../components/user-item/user-item";
import ChatBody from "../../components/chat-body/chat-body";
import {RELATION_KEY} from "../../constants/chat";
import {
    FriendInfoContainer,
    FriendInfoAvatarContainer,
    FriendInfoAvatar,
    FriendDetailContainer,
    FriendDetail,
    FriendDetailTitle,
    FriendDetailValue
} from './friends.styles';
import {useTranslation} from "react-i18next";
import Notification from "../../helpers/notifications";
import Placeholder from '../../assets/Images/profile-placeholder.png'

const Friends = () => {

    const [friends, setFriends] = useState([]);
    const [friendInfo, setFriendInfo] = useState({});
    const [openInMobile, setOpenInMobile] = useState(false);

    const [t] = useTranslation();

    useEffect(() => {

        (async () => {
            try {
                db.ref('friends').orderByChild('user').equalTo(auth().currentUser.uid)
                    .limitToFirst(10).on('value', snapshot => {
                    const friendsList = [];
                    snapshot.forEach((snap) => {
                        friendsList.push(snap.val());
                    })
                    setFriends(friendsList);
                    setFriendInfo(friendsList[0] ? friendsList[0].friend : auth().currentUser);
                });
            } catch (e) {
                Notification.danger(e.message)
            }
        })();
    }, []);

    const onSelectContact = async (contactData) => {
        setFriendInfo(contactData.friend);

        if(window.innerWidth <= 1200)
            setOpenInMobile(true);
    }

    const closeOnMobileHandler = () => {
        setFriendInfo({});
        setOpenInMobile(false);
    }

    return (
        <Main userSecTitle={t('friend list')} userSecChildren={(() => {
            return <>
                {
                    friends.length > 0 ? friends.map((item, index) =>
                        <UserItem
                            key={index}
                            active={item.friend.uid === friendInfo.uid}
                            unreadCount={item.unreadMessage}
                            clickHandler={() => onSelectContact(item)}
                            imageSource={item.friend.photoURL}
                            userName={item.friend.displayName}
                            userStatus={item.friend.online ? 'online' : 'offline'}
                            lastMessage={item.relationKey.split(RELATION_KEY)[0] === auth().currentUser.uid ? t('you added') : t('added you')}/>
                    ) : <p className='text-center mt-3'>{t('empty friends list')}</p>
                }
            </>

        })()}>
            <ChatBody isWritingMessage={false} openInMobile={openInMobile}>
                <div className='w-100 h-100 p-4'>
                    <button className='simple-btn mb-3 text-start d-xl-none' onClick={closeOnMobileHandler}>
                        <i className="fas fa-chevron-left main-text-color"/>
                    </button>
                    <FriendInfoContainer className='d-flex flex-column align-items-center justify-content-center'>
                        <FriendInfoAvatarContainer>
                            <FriendInfoAvatar src={friendInfo.photoURL ? friendInfo.photoURL : ''} alt='avatar' onError={(e) => e.target.src=Placeholder}/>
                        </FriendInfoAvatarContainer>
                        <h5 className='mt-3'>{friendInfo.displayName}</h5>
                    </FriendInfoContainer>
                    <FriendDetailContainer>
                        <FriendDetail className='lng-dir'>
                            <div>
                                <FriendDetailTitle className='lng-text'>{t('tel')}</FriendDetailTitle>
                                <FriendDetailValue className='lng-text'>{friendInfo.phoneNumber ? friendInfo.phoneNumber : t('undefined')}</FriendDetailValue>
                            </div>
                            <i className="fas fa-phone-alt text-muted"/>
                        </FriendDetail>
                        <FriendDetail className='lng-dir'>
                            <div>
                                <FriendDetailTitle className='lng-text'>{t('email')}</FriendDetailTitle>
                                <FriendDetailValue className='lng-text'>{friendInfo.email}</FriendDetailValue>
                            </div>
                            <i className="fas fa-at text-muted"/>
                        </FriendDetail>
                    </FriendDetailContainer>
                </div>
            </ChatBody>
        </Main>
    );
};

export default Friends;
